
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Editor } from '@tiptap/core';
import MenuButton from '@/components/tiptap/Menu/MenuButton.vue';

@Component({
  components: {
    MenuButton,
  },
})
export default class MenuIndentButton extends Vue {
  @Prop({ required: true }) editor: Editor;

  runCommand() {
    this.editor.chain().focus().indent().run();
  }
}
